const { location } = require('@wix/site-location');
const { window } = require('@wix/site-window');

const { handleParam, setParamInSession } = require('./paramsHandler');
const { IS_QA_KEY } = require('./qa');

const BRANCH_ID_KEY = 'branchId';
const SITE_REVISION_VALUE = '2';

async function handleBranchId() {
  const url = await location.url();
  const parsedUrl = new URL(url);
  const isQa = parsedUrl.searchParams.get(IS_QA_KEY);

  const method = async (paramKey, paramFromUrl) => {
    if (isQa) {
      console.log(
        'QA environment detected. Branch ID will be set in session storage without opening the lightbox.'
      );
      await setParamInSession(paramKey, paramFromUrl);
    } else {
      window.openLightbox('preview-version', { branchId: paramFromUrl });
    }
  };

  return await handleParam(BRANCH_ID_KEY, method, { siteRevision: SITE_REVISION_VALUE });
}

module.exports = {
  handleBranchId,
};
